import httpClient from "@/api/config";
import _findIndex from 'lodash/findIndex';
import _cloneDeep from 'lodash/cloneDeep';

export default {
	namespaced: true,

	state: {
		organization: {},
		organizations:[]
	},

	actions: {
		fetchOrganizations(context, page = 1) {
			return httpClient.get(`/v2/organization`, {
				params: {page}
			}).then(({data}) => {
				return data
			})
		},

		fetchOrganization({commit}, {organization_uuid}) {
			return httpClient.get(`/v2/organization/${organization_uuid}`)
				.then(({data}) => {
					commit('setOrganization', data.organization);
				})

		},

		addOrganization({commit, rootState}, data) {
			return httpClient.post(`${process.env.VUE_APP_URL}/v2/organization`, data)
				.then(({data: {organization}}) => {
					commit('setNewOrganization', organization);
					let filterOrgs = _cloneDeep(rootState.organizationFilterList);
					filterOrgs.unshift(organization);
					commit('setOrganizationFilterList', filterOrgs, {root: true});
				})
		},

		updateOrganization(context, {data, organization_uuid}) {
			return httpClient.put(`/v2/organization/${organization_uuid}`, data)
		},

		deleteOrganization({commit}, organization_uuid) {
			return httpClient.delete(`/v2/organization/${organization_uuid}`).then(({data}) => {
				commit('removeOrganization', data)
			})
		}
	},

	mutations: {
		setOrganizations(state, organizations){
			state.organizations = organizations
		},

		setOrganization(state, organization){
			state.organization = organization;
		},
		setNewOrganization(state, organization) {
			state.organizations.unshift(organization);
		},
		removeOrganization(state, {organization}) {
			let index = _findIndex(state.organizations,(org) => org.uuid === organization.uuid);
			state.organizations.splice(index, 1)
		}
	},

	getters: {}
}
